import DOMPurify from "isomorphic-dompurify";

export default {
  // Called when the directive is first bound to the element
  bind(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value || "");
  },

  // Called whenever the bound value changes
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = DOMPurify.sanitize(binding.value || "");
    }
  },
};
